import { Link } from "react-router-dom";
import { mangaCategories } from "@/mocks/mangaCategories";
import { mangaList } from "@/mocks/mangaList";

export default function CategoryNav() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="category-heading">
      <div className="mb-6 flex items-center gap-2.5">
        <span className="h-6 w-1.5 rounded-full bg-primary-500" aria-hidden="true" />
        <h2 id="category-heading" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          漫画分类
        </h2>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {mangaCategories.map((category) => {
          const count = mangaList.filter((m) => m.categories.includes(category.id)).length;
          return (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-100/60 px-4 py-6 text-center transition-all hover:border-primary-300 hover:bg-background-50"
              title={`${category.name}漫画专区`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50 text-xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={category.icon} aria-hidden="true" />
              </span>
              <span className="text-sm font-bold text-foreground-950">{category.name}</span>
              <span className="text-xs text-foreground-500">{count > 0 ? `${count} 部作品` : "更多作品"}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}